import { UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";

const UserAvatar = ({ size = 20 }) => (
  <Avatar
    size={size}
    icon={<UserOutlined />}
    style={{ backgroundColor: "#6B7280" }}
  />
);

export default UserAvatar;
